"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es7.object.entries");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.string.iterator");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _loading = require("@/mixins/loading/loading");

var _permission = require("@/mixins/permission/permission");

var _elementUi = require("element-ui");

var _numberCount = _interopRequireDefault(require("@/components/number-count/number-count.vue"));

var _miniGanttChart = _interopRequireDefault(require("@/components/mini-gantt-chart/mini-gantt-chart.vue"));

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

var _mapChina = _interopRequireDefault(require("@/components/map-china/map-china.vue"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CarrierDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(CarrierDashboardComponent, _Mixins);

  var _super = _createSuper(CarrierDashboardComponent);

  function CarrierDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, CarrierDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.requestParameters = {};
    _this.locations = {};
    _this.truckData = [];
    _this.dashboardData = [];
    _this.dashboardDataSummary = {
      'availableOrder': 0,
      'completedOrder': 0,
      'latlngHeatMap': []
    };
    _this.searchFilter = 'planId';
    _this.searchText = '';
    _this.sTruck = null;
    _this.sIndex = -1;
    return _this;
  }

  (0, _createClass2.default)(CarrierDashboardComponent, [{
    key: "onSTextChanges",
    value: function onSTextChanges(newVal) {
      if (newVal === '') {
        this.sTruck = null;
      }
    }
  }, {
    key: "$planDate",
    get: function get() {
      return this.$store.getters['lastMileDelivery/planDate'];
    },
    set: function set(newVal) {
      this.$setPlanDate(newVal);
    }
  }, {
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.loading = true;
      this.locations = {
        'latitude': this.$userData.latlng.split(',')[0],
        'longitude': this.$userData.latlng.split(',')[1]
      };
      this.updateData();
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "latLng",
    value: function latLng() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (data && data['data'] && data['data'].length >= 1) {
        return data['data'].reduce(function (finalData, rData) {
          if (rData && rData['routes'] && rData['routes'].length >= 1) {
            rData['routes'].forEach(function (wpData) {
              if (wpData['latitude'] && wpData['longitude']) {
                finalData.push([wpData['latitude'], wpData['longitude']]);
              }
            });
          }

          return finalData;
        }, []);
      } else {
        return [];
      }
    }
  }, {
    key: "updateMarker",
    value: function updateMarker() {
      var _this2 = this;

      var truckIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var index = arguments.length > 1 ? arguments[1] : undefined;
      var heatMap = this.$refs.heatMap;
      heatMap.removeMarker(index);

      if (this.dashboardData && this.dashboardData[index] && this.dashboardData[index]['routing'] && this.dashboardData[index]['routing']['data'] && this.dashboardData[index]['routing']['data'].length >= 1 && truckIds && truckIds.length >= 1 && typeof heatMap !== 'undefined') {
        truckIds.forEach(function (truckId, truckIdx) {
          var routesList = _this2.dashboardData[index]['routing']['data'].find(function (rData) {
            return rData && rData['routes'] && rData['routes'].length >= 1 && rData['truckId'] && rData['truckId'] === truckId;
          });

          if (routesList) {
            var locationsList = [];
            routesList['routes'].forEach(function (wpData) {
              if (wpData['latitude'] && wpData['longitude']) {
                locationsList.push({
                  'latitude': wpData['latitude'],
                  'longitude': wpData['longitude']
                });
              }
            });

            if (locationsList.length >= 1) {
              heatMap.addMarker(locationsList, _this2.getVehicleColor(truckId), index);
            }
          }
        });
      }
    }
  }, {
    key: "getVehicleColor",
    value: function getVehicleColor(truckId) {
      var color = this.$dashboardVehicles.find(function (vehicle) {
        return vehicle['id'] === truckId;
      });
      return color && color['color'] ? color['color'] : '#387fc2';
    }
  }, {
    key: "handlePlanDateChanges",
    value: function handlePlanDateChanges() {
      this.loading = true;
      this.updateData();
    }
  }, {
    key: "updateData",
    value: function updateData() {
      var _this3 = this;

      if (this.$userInformation.carrier && this.$userInformation.carrier.length >= 1) {
        var promises = [];
        this.$userInformation.carrier.forEach(function (carrierData) {
          if (carrierData.key && carrierData.code) {
            var carrierParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, carrierData.key);
            promises.push(_this3.request.get('AI_ROUTE_DASHBOARD', "routing/".concat(_this3.$planDate), carrierParameters));
          }
        });
        Promise.all(promises).then(function (results) {
          if (results && results.length >= 1) {
            _this3.dashboardData = [];
            results.forEach(function (resData, resIndex) {
              if (resData.status && resData.status === 'success' && resData.data) {
                _this3.dashboardData.push(_objectSpread({
                  'key': _this3.$userInformation.carrier[resIndex]
                }, resData.data));

                if (resData.data.count) {
                  _this3.dashboardDataSummary['availableOrder'] = _this3.dashboardDataSummary['availableOrder'] + Number(resData.data.count.availableOrder || 0);
                  _this3.dashboardDataSummary['completedOrder'] = _this3.dashboardDataSummary['completedOrder'] + Number(resData.data.count.completedOrder || 0);
                }

                if (resData.data.routing) {
                  _this3.dashboardDataSummary['latlngHeatMap'] = [].concat((0, _toConsumableArray2.default)(_this3.dashboardDataSummary['latlngHeatMap']), (0, _toConsumableArray2.default)(_this3.latLng(resData.data.routing)));
                }
              }
            });
          }

          _this3.loading = false;
        }).catch(function (error) {
          _this3.$router.push({
            path: '/dashboard'
          });
        });
      } else {
        this.$router.push({
          path: '/dashboard'
        });
      }
    }
  }, {
    key: "searchTruck",
    value: function searchTruck() {
      var _this4 = this;

      var searchQuery = this.searchText.trim().toLowerCase();
      var fComps = this.dashboardData.filter(function (company) {
        return !(Object.entries(company.routing).length === 0 && company.routing.constructor === Object);
      });
      var mappedTrucks = this.helper.flatten(fComps.map(function (c) {
        return c.routing.data;
      }));
      var selectedTrucks = mappedTrucks.filter(function (truck) {
        return truck[_this4.searchFilter].find(function (item) {
          return item.toString().trim().toLowerCase().includes(searchQuery);
        });
      });
      this.sTruck = selectedTrucks.length === 1 ? selectedTrucks[0].truckId : null;
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }]);
  return CarrierDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _helper.HelperMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], CarrierDashboardComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], CarrierDashboardComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], CarrierDashboardComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('dashboardVehicles', {
  namespace: 'common'
})], CarrierDashboardComponent.prototype, "$dashboardVehicles", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_DATE', {
  namespace: 'lastMileDelivery'
})], CarrierDashboardComponent.prototype, "$setPlanDate", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('searchText')], CarrierDashboardComponent.prototype, "onSTextChanges", null);
CarrierDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'CarrierDashboardComponent',
  components: {
    'number-count': _numberCount.default,
    'mini-gantt-chart': _miniGanttChart.default,
    'map-world': _mapWorld.default,
    'map-china': _mapChina.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-card': _elementUi.Card,
    'el-date-picker': _elementUi.DatePicker,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-input': _elementUi.Input,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem
  }
})], CarrierDashboardComponent);
var _default = CarrierDashboardComponent;
exports.default = _default;